import TryItNow from '~/main_app/pages/try-it-now'

export default TryItNow
